import { api } from "@/app/services/api.service";
import { extractErrorMessage } from "./mobileApiUtils";

export { extractErrorMessage };

export const MOBILE_APP_KEYS_PATH = "configuration/integration/mobile-app-keys";

export type MobileAppKeys = {
  adminUnitsApiKey: string | null;
  servicesPaymentApiKey: string | null;
  configured: boolean;
};

function unwrapPayload(res: { data: unknown }) {
  const data = res.data as Record<string, unknown>;
  if (
    data != null &&
    typeof data === "object" &&
    Object.prototype.hasOwnProperty.call(data, "data") &&
    data.data != null
  ) {
    return data.data;
  }
  return data;
}

function readString(record: Record<string, unknown>, keys: string[]) {
  for (const key of keys) {
    const value = record[key];
    if (value != null && value !== "") return String(value);
  }
  return null;
}

export function parseMobileAppKeys(body: unknown): MobileAppKeys {
  if (body == null || typeof body !== "object") {
    return {
      adminUnitsApiKey: null,
      servicesPaymentApiKey: null,
      configured: false,
    };
  }

  const record = body as Record<string, unknown>;
  const adminUnitsApiKey = readString(record, [
    "adminUnitsApiKey",
    "admin_units_api_key",
    "ADMIN_UNITS_API_KEY",
  ]);
  const servicesPaymentApiKey = readString(record, [
    "servicesPaymentApiKey",
    "services_payment_api_key",
    "SERVICES_PAYMENT_API_KEY",
  ]);

  const configured =
    (adminUnitsApiKey != null && adminUnitsApiKey.length > 0) ||
    (servicesPaymentApiKey != null && servicesPaymentApiKey.length > 0);

  return {
    adminUnitsApiKey,
    servicesPaymentApiKey,
    configured,
  };
}

export async function fetchMobileAppKeys(): Promise<MobileAppKeys> {
  const res = await api().get(MOBILE_APP_KEYS_PATH);
  return parseMobileAppKeys(unwrapPayload(res));
}

export async function saveMobileAppKeys(payload: {
  adminUnitsApiKey: string;
  servicesPaymentApiKey: string;
}) {
  await api().post(MOBILE_APP_KEYS_PATH, payload);
}

export async function deleteMobileAppKeys() {
  await api().delete(MOBILE_APP_KEYS_PATH);
}
